import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhSocialShareComponent } from '@shared/components/ph-social-share/ph-social-share.component';

@NgModule({
  declarations: [PhSocialShareComponent],
  exports: [PhSocialShareComponent],
  imports: [CommonModule],
})
export class PhSocialShareModule {}
